app.factory('analyticsService', ['sessionService', '$q',
    function(sessionService, $q) {
        var obj = {
            _push_custom_event_data_to_datalayer: function(eventName, eventObj) {
                var defer = $q.defer();
                if (window.dataLayer) {
                    eventObj['event'] = 'WD-' + eventName;
                    if (sessionService.isLoggedIn()) {
                        eventObj['userId'] = sessionService.get('cognito_username');
                    }
                    window.dataLayer.push(eventObj);
                }
                defer.resolve();
                return defer.promise;
            }
        }
        return obj;
    }
]);
